import { Link } from 'react-router-dom';

export default function DirectoryCTA() {
  return (
    <section className="py-16 bg-gradient-to-r from-teal-700 via-teal-800 to-teal-700">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <div className="max-w-2xl mx-auto">
          <div className="w-14 h-14 bg-amber-500 rounded-2xl flex items-center justify-center mx-auto mb-5">
            <i className="ri-megaphone-line text-white text-2xl"></i>
          </div>
          <h2 className="text-3xl font-bold text-white mb-3">
            Own a Local Business?
          </h2>
          <p className="text-white/80 mb-8 leading-relaxed">
            Get your business listed in the Roseville directory and reach thousands of local residents.
            Plans start at just $49/month.
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link
              to="/submit-business"
              className="inline-flex items-center gap-2 px-7 py-3 bg-white hover:bg-gray-50 text-teal-800 font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-edit-line"></i>
              Submit Your Business
            </Link>
            <Link
              to="/advertise"
              className="inline-flex items-center gap-2 px-7 py-3 bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-add-line"></i>
              List Your Business
            </Link>
            <Link
              to="/deals"
              className="inline-flex items-center gap-2 px-7 py-3 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap border border-white/20"
            >
              <i className="ri-coupon-line"></i>
              View Deals &amp; Coupons
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
